import { Typography } from 'antd';
import { PropsWithChildren } from 'react';

import styles from './index.module.scss';

export const ContentTitle = ({ children }: PropsWithChildren) => {
  return <Typography className={styles.pageTitle}>{children}</Typography>;
};
